export const ButtonManager = {
  buttonSelector: 'a.btn-single-click, button.btn-single-click',

  init: function () {
    ButtonManager.initSingleClickButtons();
  },

  initSingleClickButtons: function () {
    $(document).on('click', ButtonManager.buttonSelector, function () {
      var $this = $(this);
      $this.data('loading-text', '<i class=\'fa fa-spinner fa-spin mr-5\'></i>' + $this.text());
      $this.button('loading');
    });
  },

  resetSingleClickButtons: function () {
    $(ButtonManager.buttonSelector).button('reset');
  }
};
